import { render, staticRenderFns } from "./TrialBox.vue?vue&type=template&id=bff2ee78&scoped=true&"
import script from "./TrialBox.vue?vue&type=script&lang=js&"
export * from "./TrialBox.vue?vue&type=script&lang=js&"
import style0 from "./TrialBox.vue?vue&type=style&index=0&id=bff2ee78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff2ee78",
  null
  
)

export default component.exports